// TODO：generateSliderSwiperの最適化
// 将来的にはgenerateSliderSwiperを共通関数としてではなく、sections/top-slider.liquidとsections/topics-slider.liquidそれぞれに最適化したい
// spFixedMaxCount / pcFixedMaxCount: SP/PCそれぞれ、この枚数以下の場合はスクロールを無効にする（デフォルト0＝常にスクロール）
const generateSliderSwiper = (source, sectionId, pcSlideSpeed=300, mobileSlideSpeed=300, displaySlide=3, spFixedMaxCount=0, pcFixedMaxCount=0) => {
  const blockSize = (source > 1) ? source : 1;
  // ※判定は読み込み時のみ。読み込み後にPC/SPを跨いでも追従しない
  const isPc = window.matchMedia('(min-width: 751px)').matches;
  const scrollable = blockSize > (isPc ? pcFixedMaxCount : spFixedMaxCount);
  const autoplay = scrollable ? {delay: 5000, disableOnInteraction: false} : false;
  const pagination = scrollable ? {el: `.swiper-${sectionId}-pagination`, type: 'bullets', clickable: true} : false;
  const navigation = scrollable ? {nextEl: `.swiper-${sectionId}-button-next`, prevEl: `.swiper-${sectionId}-button-prev`, addIcons: false} : false;

  const generated = new Swiper(`.swiper-${sectionId}`, {
    centeredSlides: scrollable,
    initialSlide: 0,
    loop: scrollable,
    allowTouchMove: scrollable,
    autoplay: autoplay,
    pagination: pagination,
    navigation: navigation,
    init: false,
    loopAdditionalSlides: 1,
    breakpoints: {
      1: {
        slidesPerView: (displaySlide == 3) ? 1.1 : 2.0,
        speed: mobileSlideSpeed
      },
      751: {
        slidesPerView: (displaySlide == 3) ? 2.8 : 4.0,
        speed: pcSlideSpeed
      }
    }
  });

  generated.on('breakpoint', (swiper, breakpointParams) => {
    swiper.updateSize();
  });
  

  return generated;
}